import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { IncomeInformationStepContent } from "Components/Onboarding/BusinessEntity/Steps/IncomeInformationStep/IncomeInformationStepContent";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useCurrentUserActingPersonParty } from "Hooks/useCurrentUserActingPersonParty";
import { useCurrentUserParty } from "Hooks/useCurrentUserParty";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onNextStepRequested: () => void;
};

export const IncomeInformationStep = ({ onNextStepRequested }: Props) => {
  const { t } = useResource();
  const { data: verificationData, isLoading: isVerificationsLoading } =
    useVerificationsQuery();
  const { data: partyData, isLoading: isPartyLoading } = useCurrentUserParty();
  const { partyRelation, isLoading: isActingPersonPartyLoading } =
    useCurrentUserActingPersonParty();

  if (isVerificationsLoading || isPartyLoading || isActingPersonPartyLoading) {
    return <CenteredCircularProgress color="grey" />;
  }

  const companyPartyPublicID = partyData?.publicID;

  if (!verificationData || !partyData || !companyPartyPublicID) {
    return <ErrorText>{t(Resources.Errors.DataLoadingError)}</ErrorText>;
  }

  return (
    <IncomeInformationStepContent
      onNextStepRequested={onNextStepRequested}
      verificationData={verificationData}
      partyType={partyData.type}
      companyPartyPublicID={companyPartyPublicID}
      actingPersonPartyRelation={partyRelation}
    />
  );
};
